import { render } from "./i4.vue?vue&type=template&id=4b7cde36&scoped=true"
const script = {}

import "./i4.vue?vue&type=style&index=0&id=4b7cde36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7cde36"]])

export default __exports__